export default "__VITE_ASSET__Bu1$$lip__"